import { render, staticRenderFns } from "./BoothQuickPropsEditor.vue?vue&type=template&id=27cf64dd"
import script from "./BoothQuickPropsEditor.vue?vue&type=script&lang=ts"
export * from "./BoothQuickPropsEditor.vue?vue&type=script&lang=ts"
import style0 from "./BoothQuickPropsEditor.vue?vue&type=style&index=0&id=27cf64dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports